module.exports = __webpack_public_path__ + "img/keycase-1.e606f109.jpg";